import styled from 'styled-components';

export const AccordionOptions = styled.div<{ maxHeight: number }>`
  background-color: #f5f5f5;
  overflow: hidden;
  transition: max-height 0.3s ease;
  max-height: ${({ maxHeight }) => `${maxHeight}px`};
`;
